/**
 * FileDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileDeleteReq
 */
export interface FileDeleteReq {
  /** 文件ID（单个删除时使用路径参数） */
  id?: string
  /** 文件ID列表（批量删除时使用查询参数） */
  ids?: string[]
}

/**
 * FileDeleteReq Schema
 */
export const FileDeleteReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '文件ID（单个删除时使用路径参数）',
      format: 'string',
      type: 'string',
      label: '文件ID',
    },
    ids: {
      description: '文件ID列表（批量删除时使用查询参数）',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '文件ID列表',
    },
  },
  type: 'object',
}
